export const RESERVED_CITY_SLUGS = new Set([
  "api",
  "events",
  "create",
  "login",
  "me",
  "my-events",
  "faq",
  "support",
  "for-organizers",
  "host",
  "dashboard",
  "e",
  "demo",
  "static",
  "schools",
  "school",
  "classes",
  "admin",
  "app-admin",
  "switch-user",
  "onboarding",
  "auth",
]);

const PUBLIC_BASE = (
  process.env.REACT_APP_PUBLIC_URL ||
  process.env.REACT_APP_APP_URL ||
  (typeof window !== "undefined" ? window.location.origin : "") ||
  ""
).replace(/\/$/, "");

export function eventPublicPath(event) {
  if (event?.public_path) return event.public_path;
  if (event?.city_slug && event?.public_slug) {
    return `/${event.city_slug}/${event.public_slug}`;
  }
  return null;
}

export function eventInviteUrl(event) {
  if (event?.invite_url) {
    const u = event.invite_url;
    if (u.startsWith("http://") || u.startsWith("https://")) return u;
    return `${PUBLIC_BASE}${u.startsWith("/") ? u : `/${u}`}`;
  }
  const path = eventPublicPath(event);
  return path ? `${PUBLIC_BASE}${path}` : PUBLIC_BASE;
}

export function eventEditPath(event) {
  return `/e/${event.id}/edit`;
}

export function checkInPathFor(eventOrActive, occurrenceDate = null) {
  const base = eventPublicPath(eventOrActive);
  if (!base) return null;
  const occ = occurrenceDate || eventOrActive?.occurrence_date || null;
  const qs = occ ? `?occurrence_date=${encodeURIComponent(occ)}` : "";
  return `${base}/check-in${qs}`;
}

export function gamePathFor(eventOrActive, gameSlug, occurrenceDate = null) {
  const base = eventPublicPath(eventOrActive);
  if (!base) return null;
  const occ = occurrenceDate || eventOrActive?.occurrence_date || null;
  const qs = occ ? `?occurrence_date=${encodeURIComponent(occ)}` : "";
  return `${base}/game/${gameSlug}${qs}`;
}
